import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const syncCalendar = createAsyncThunk('calendar/sync', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/property-schedule/sync-calender')
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  calendarData: null,
  error: null
}

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(syncCalendar.pending, (state) => {
        state.isLoading = true
      })
      .addCase(syncCalendar.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(syncCalendar.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default calendarSlice.reducer
